import Axios from '../axios-instance';

const ExchangeDifferenceAPI = {
  getExchangeDifferences: body => {
    return Axios.post('/ExchangeDifferences/Get', body).then(({ data }) => data);
  },
};

export default ExchangeDifferenceAPI;
